import { Box } from './Box';
export const Image = Box.withComponent('img');

//# sourceMappingURL=Image.js.map
